/*
 * Ryan O'Dowd
 * 2024-05-24
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import Button from '@components/common/Button';
import IconButton from '@components/common/IconButton';
import Menu from '@components/common/Menu';
import Tooltip from '@components/common/Tooltip';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import globals from '@utils/globals';
import hooks from '@hooks';

const NavigationTabs = () => {
  const styles = hooks.useStyles(getStyles);
  const navigation = hooks.useNavigation();
  const initialTabValue = location.pathname.split('/')[location.pathname.split('/').length - 1];

  const tabs = [
    {
      value: '',
      label: 'Overview',
      linkTo: '/',
      icon: 'home',
    },
    {
      value: 'schools',
      label: 'Schools',
      linkTo: '/schools',
      icon: 'school',
    },
    {
      value: 'fundraising',
      label: 'Fundraising',
      linkTo: '/fundraising',
      icon: 'hand-heart',
    },
    /* @TODO:
    {
      value: 'app',
      label: 'App',
      linkTo: '/app',
      icon: 'laptop',
    },
    */
  ];

  const [_tabValue, setTabValue] = useState(tabs.map((tab) => tab.value).includes(initialTabValue) ? initialTabValue : false); // @TODO: should be a 404 if it's not / or in TABS @TODO: this isn't always accurate (for example, /organizations/../../..)
  const [_isNavMenuOpen, setIsNavMenuOpen] = useState(false);

  if (globals.deviceType === 'mobile') {
    return (
      <Menu
        anchor={
          <Tooltip title='More options'>
            <IconButton
              icon='menu'
              iconColor={styles.colors.white}
              onPress={() => setIsNavMenuOpen(true)}
            />
          </Tooltip>
        }
        visible={_isNavMenuOpen}
        onDismiss={() => setIsNavMenuOpen(false)}
      >
        {tabs.map((tab) => {
          return (
            <Menu.Item
              key={tab.value}
              title={tab.label}
              leadingIcon={tab.icon}
              onPress={() => {
                navigation.navigate(tab.linkTo);
                setIsNavMenuOpen(false);
              }}
            />
          );
        })}
      </Menu>
    );
  }

  return (
    <View style={styles.container}>
      {tabs.map((tab) => {
        const isSelected = tab.value === _tabValue;
        return (
          <Button
            key={tab.value}
            style={[styles.tab, isSelected && styles.selectedTab]}
            labelStyle={[styles.tabLabel, isSelected && styles.selectedTabLabel]}
            mode={isSelected ? 'outlined' : 'text'}
            theme={isSelected ? styles.colors.accent : styles.colors.primaryExtraLight}
            onPress={() => {
              // @TODO: if ctrl+click, open new tab, don't navigate or change tab
              navigation.navigate(tab.linkTo);
              setTabValue(tab.value);
            }}
          >
            {tab.label}
          </Button>
        );
      })}
    </View>
  );
};

export default NavigationTabs;
